import * as React from 'react';
import { DataComponentProps } from './DataComponentProps';
import { ComboBox, Item, Key } from '@adobe/react-spectrum';
import { useState } from 'react';
import { useDataContext } from './Contexts/DataContext';

export interface IResponsibleUserDropDownProps extends DataComponentProps {
    
}

export function ResponsibleUserDropDown ({
    compKey, 
  label, 
  width, 
  isRequired, 
  onValueChange 
}: IResponsibleUserDropDownProps) {
  const message = `${label} is required`;
  const [errorMessage, setErrorMessage] = useState(isRequired ? message : '');
  const [value, setValue] = useState<Key | null>('');
  const [input, setInput] = useState('');
  const { getUserData } = useDataContext();
  const { data, error, loading } = getUserData();

  const onSelectionChange = (value: Key | null) => {
    if(onValueChange)
        onValueChange(value ? value.toString() : '', input);
    setValue(value);
    if(isRequired && !value) 
      setErrorMessage(message);
    else 
      setErrorMessage('');
  };

  const onInputChange = (value: string) => {
    setInput(value);
  }
  
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <ComboBox key={compKey} 
        label={label} 
        width={width} 
        isRequired={isRequired} 
        selectedKey={value}
        onSelectionChange={onSelectionChange} 
        onInputChange={onInputChange}
        validationState={errorMessage ? 'invalid' : undefined}
        errorMessage={errorMessage}
        >
      {data.map((item) => (
        <Item key={`${item.id}_${item.contactId}`} textValue={item.contactName}>
          {item.contactName}
        </Item>
      ))}
    </ComboBox>
  );
}
